import { RegisterApi } from '../../api/auth';
import { Util } from '../../common/util/util';
import { basketActions } from '../../store/basket/basket.slice';
import { userActions } from '../../store/user/user.slice';
import { Basket } from '../Basket';

export class Auth {
  public static async Logout(
    dispatch: any,
    sessionToken: string,
    setSessionToken: any
  ) {
    const { setAuthModal } = userActions;
    const { setBasketCatalogItems, setOrderQuantity, setOrderSum } =
      basketActions;
    const { setIsOffline, setLoggedIn, setSuperAdmin } = userActions;
    try {
      await RegisterApi().setLogout(sessionToken);
      setSessionToken('');

      //Сохраняем также на другой домен:
      Util.crossDomainLocalStorageSetItem('st', '');
      Util.crossDomainLocalStorageSetItem('pe', '');
      Util.crossDomainLocalStorageSetItem('p', '');
      Util.crossDomainLocalStorageSetItem('e', '');
      // Не залогинен
      dispatch(setLoggedIn(false));
      // Не супер админ
      dispatch(setSuperAdmin(false));
      //Сохраняем в LocalStorage
      Basket.saveToLocalStorage([]);
      //Сохраняем в Redux
      dispatch(setBasketCatalogItems([]));
      dispatch(setOrderSum(0));
      dispatch(setOrderQuantity(0));
    } catch (error) {
      dispatch(setIsOffline(true));
      console.warn('Register error', error);
    } finally {
      dispatch(setAuthModal(false));
    }
  }
}
